import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL, PARSE_APPLICATION_ID, PARSE_REST_API_KEY } from "../api";

export const getAllStores = createAsyncThunk(
  "adminStores/getAllStores",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Store";
      const user = getState().user.userMe;
      const options = {
        method: "GET",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
      };

      const res = await fetch(url, options);

      const data = await res.json();
      if (data.error) {
        rejectWithValue(res.error);
      }
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const createStore = createAsyncThunk(
  "adminStores/createStore",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Store";
      const user = getState().user.userMe;
      let body = null;
      if (!payload.product_dictionaries[0].objectId) {
        body = JSON.stringify({
          name: payload.name,
          pib: payload.pib,
        });
      } else {
        body = JSON.stringify({
          name: payload.name,
          pib: payload.pib,
          product_dictionaries: payload.product_dictionaries,
        });
      }
      const options = {
        method: "POST",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
        body: body,
      };

      const res = await fetch(url, options);

      const data = await res.json();
      if (data.error) {
        rejectWithValue(res.error);
      }
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const updateStore = createAsyncThunk(
  "adminStores/updateStore",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Store/" + payload.objectId;
      const user = getState().user.userMe;

      let body = null;
      if (!payload.product_dictionaries[0].objectId) {
        body = JSON.stringify({
          name: payload.name,
          pib: payload.pib,
        });
      } else {
        body = JSON.stringify({
          name: payload.name,
          pib: payload.pib,
          product_dictionaries: payload.product_dictionaries,
        });
      }

      const options = {
        method: "PUT",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
        body: body,
      };

      const res = await fetch(url, options);

      const data = await res.json();
      if (data.error) {
        rejectWithValue(res.error);
      }
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const deleteStore = createAsyncThunk(
  "adminStores/deleteStore",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Store/" + payload.objectId;
      const user = getState().user.userMe;
      const options = {
        method: "DELETE",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
      };

      const res = await fetch(url, options);

      const data = await res.json();
      if (data.error) {
        rejectWithValue(res.error);
      }
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  getAllStoresLoading: "IDLE",
  getAllStoresError: null,
  allDefinedStores: null,
  createStoreLoading: "IDLE",
  createStoreError: null,
  updateStoreLoading: "IDLE",
  updateStoreError: null,
  deleteStoreLoading: "IDLE",
  deleteStoreError: null,
};

export const adminStoresSlice = createSlice({
  name: "adminStores",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllStores.pending, (state, action) => {
      state.getAllStoresLoading = "PENDING";
      state.getAllStoresError = null;
    });
    builder.addCase(getAllStores.fulfilled, (state, action) => {
      state.getAllStoresLoading = "SUCCESS";
      state.getAllStoresError = null;
      state.allDefinedStores = action.payload.results;
    });
    builder.addCase(getAllStores.rejected, (state, action) => {
      state.getAllStoresLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.getAllStoresError = err;
    });

    builder.addCase(createStore.pending, (state, action) => {
      state.createStoreLoading = "PENDING";
      state.createStoreError = null;
    });
    builder.addCase(createStore.fulfilled, (state, action) => {
      state.createStoreLoading = "SUCCESS";
      state.createStoreError = null;
    });
    builder.addCase(createStore.rejected, (state, action) => {
      state.createStoreLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.createStoreError = err;
    });

    builder.addCase(updateStore.pending, (state, action) => {
      state.updateStoreLoading = "PENDING";
      state.updateStoreError = null;
    });
    builder.addCase(updateStore.fulfilled, (state, action) => {
      state.updateStoreLoading = "SUCCESS";
      state.updateStoreError = null;
    });
    builder.addCase(updateStore.rejected, (state, action) => {
      state.updateStoreLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.updateStoreError = err;
    });

    builder.addCase(deleteStore.pending, (state, action) => {
      state.deleteStoreLoading = "PENDING";
      state.deleteStoreError = null;
    });
    builder.addCase(deleteStore.fulfilled, (state, action) => {
      state.deleteStoreLoading = "SUCCESS";
      state.deleteStoreError = null;
    });
    builder.addCase(deleteStore.rejected, (state, action) => {
      state.deleteStoreLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.deleteStoreError = err;
    });
  },
});

// this is for dispatch
export const {} = adminStoresSlice.actions;

// this is for configureStore
export default adminStoresSlice.reducer;
